




















































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BookingReadCandidate from './BookingReadCandidate.vue';
import BookingReadBookingCandidateFormFields from './BookingReadBookingCandidateFormFields.vue';
import BookingReadServiceCandidate from './BookingReadServiceCandidate.vue';
import { STATUSES, BOOKING_PURPOSES } from '@/constants/booking';
import { sortBy } from 'lodash';

@Component({
  components: {
    BookingReadCandidate,
    BookingReadBookingCandidateFormFields,
    BookingReadServiceCandidate,
  },
  computed: {
    ...mapState('Booking', {
      booking: 'booking',
    }),
    ...mapState('UserPreference', {
      userPreference: 'single',
    }),
  },
})
export default class BookingReadCandidateInformation extends Vue {
  booking!: Booking;
  userPreference!: Model;

  search = '';
  showSheet = false;
  selectedBookingCandidate = null;
  selectedBookingCandidateIndex = 0;
  statuses = STATUSES;
  showAdditionalService = false;
  currentPage = 1;
  itemsPerPage = 10;
  bookingPurposes = BOOKING_PURPOSES;

  get headers() {
    const header = [
      {
        text: 'Candidate',
        value: 'candidate',
        sortable: true,
      },
      {
        text: 'Department',
        value: 'department',
      },
    ];

    if (this.booking.status !== this.statuses.STATUS_CANCELLED.key) {
      header.push({
        text: 'Share Code',
        value: 'share_code',
      });
    }

    /**
     * Show the individual status if one of following conditions is true:
     * - the booking is general health check
     * - the userPreference does not exist (It means showing the status by default)
     * - ghc_booking_candidate_status_enabled in userPreference is true
     */
    if (
      (!this.isHealthCheck ||
        !this.userPreference ||
        this.userPreference?.booking_settings
          ?.ghc_booking_candidate_status_enabled) &&
      this.booking.status !== this.statuses.STATUS_CANCELLED.key
    ) {
      header.push({
        text: 'Quescreen Status',
        value: 'status',
      });
    }

    if (this.showAdditionalService) {
      header.push({
        text: 'Additional Services',
        value: 'additional_services',
      });
    }

    if (this.booking.status !== this.statuses.STATUS_CANCELLED.key) {
      header.push({
        text: 'Actions',
        value: 'actions',
        sortable: false,
      });
    }

    return header;
  }

  get isHealthCheck() {
    return (
      this.booking.purpose ===
      this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    );
  }

  get bookingCandidates() {
    return sortBy(this.booking.booking_candidates, (item) => item.status) || [];
  }

  get isBookingComplete() {
    return this.booking.status === this.statuses.STATUS_COMPLETED.key;
  }

  filterCandidate(value, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          'first_name',
          'last_name',
          'date_of_birth',
          'mobile',
          'email',
        ].includes(k) &&
        item[k]
          .toString()
          .toLowerCase()
          .includes(search)
      );
    });
  }

  editBookingCandidate(bookingCandidate, index) {
    this.showSheet = true;
    this.selectedBookingCandidate = bookingCandidate;
    this.selectedBookingCandidateIndex = index;
  }

  openAdditionalServicesDialog() {
    this.$store.commit('OPEN_DIALOG', {
      open: true,
      content: 'BookingReadServiceCandidate',
      fullscreen: true,
      floater: true,
    });
  }
}
